"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _reactFlagKit = require("react-flag-kit");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var styles = {
  flag: {
    height: 15,
    marginRight: 10
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '0.5rem'
  }
};

var createLanguageOption = function createLanguageOption(code) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : code;
  var codeUppercase = code && code.toUpperCase && code.toUpperCase();
  return _react.default.createElement(_core.MenuItem, {
    style: styles.item,
    value: code,
    key: code
  }, _react.default.createElement("div", {
    style: styles.item
  }, _react.default.createElement(_reactFlagKit.FlagIcon, {
    style: styles.flag,
    code: codeUppercase !== 'EN' ? codeUppercase : 'GB'
  }), label || code));
};

var _default = createLanguageOption;
exports.default = _default;